import React, { useEffect, useState } from 'react'
import Modal from '../Modal'
import Button from '../Button'
import Typography from '../Typography'
import PTRestAPI from '../../utils/pt_rest_api'
import { useAuth } from '../../utils/platform_auth.jsx'
import DataTable from '../DataTable'
import { showNotification } from '../Notification'
import { navigate } from 'vike/client/router'
import ToggleSwitch from '../ToggleSwitch/index.jsx'
import { PLATFORM_API_URL, PLATFORM_API_VERSION } from '../../config'

const ArticleBrowser = ({
  isOpen,
  onCloseRequested,
  onCloseBtnClick,
  controller,
}) => {
  const auth = useAuth()
  const [tableRefresh, setTableRefresh] = useState(false)

  //refresh on open
  useEffect(() => {
    if (isOpen) {
      setTableRefresh(!tableRefresh)
    }
  }, [isOpen])

  const toggleStatus = async (article) => {
    try {
      const updatedPayload = {
        ...article,
        status: article.status === 'draft' ? 'published' : 'draft',
      }
      const result = await PTRestAPI.PublishArticle(auth, updatedPayload)

      if (result.error) {
        throw new Error(result.error)
      }

      setTableRefresh(!tableRefresh)
      showNotification({
        message: `Article status updated to ${updatedPayload.status}`,
        className: 'bg-primary text-text_inv',
      })
    } catch (error) {
      showNotification({
        message: 'Failed to update status: ' + error.message,
        className: 'bg-red-500 text-text_inv',
      })
    }
  }

  const loadArticle = (id) => {
    // Implement the load action, e.g., navigate to the article edit page
    navigate(`/blog?article=${id}`)
    onCloseRequested()
  }

  const articleRender = [
    {
      id: 'thumbnail',
      title: 'Thumbnail',
      headerClassName: 'w-[100px]',
      render: (value) => {
        value = `${PLATFORM_API_URL}/${PLATFORM_API_VERSION}/blog-resource?file=${value}`
        return (
          <img src={value} alt="Thumbnail" className="w-16 h-16 object-cover" />
        )
      },
    },
    {
      id: 'title',
      title: 'Title',
      headerClassName: 'w-[500px]',
      render: (value) => <Typography className="text-text">{value}</Typography>,
    },
    {
      id: 'status',
      title: 'Status',
      headerClassName: 'w-[100px]',
      render: (value, item) => (
        <div className="w-[100px] items-center">
          <Typography className="mr-2">{value}</Typography>
          <ToggleSwitch
            isOn={value === 'published'}
            onChange={() => toggleStatus(item)}
          />
        </div>
      ),
    },
    {
      id: 'preview',
      title: '',
      headerClassName: 'w-[100px]',
      render: (value, item) => {
        return (
          <Button variant="action" onClick={() => loadArticle(item.articleID)}>
            Preview
          </Button>
        )
      },
    },
  ]

  return (
    <Modal
      isOpen={isOpen}
      closeOnEscape={true}
      onCloseRequested={onCloseRequested}
      onCloseBtnClick={onCloseBtnClick}
      className="w-full sm:w-[500px] md:absolute md:top-[65px] h-full md:h-auto sm:max-w-[700px] bg-paper text-sm sm:text-base z-200"
    >
      <div>
        <Typography variant="h3" className="text-text mb-4">
          Article Browser
        </Typography>

        {/* Article List */}
        <div className="min-h-[100px]">
          <DataTable
            title={'Articles'}
            refreshKey={tableRefresh}
            preferredHeight="400px"
            itemHeight="h-[20px]"
            apiMethod={PTRestAPI.ListArticles}
            apiDataField={'articles'}
            searchField={'title'}
            renders={articleRender}
            noData={
              <Typography variant="h5" className="text-text">
                {`No articles found`}
              </Typography>
            }
          />
        </div>
      </div>
    </Modal>
  )
}

export default ArticleBrowser
